import { createAsyncThunk } from '@reduxjs/toolkit';
import ax from 'services/apiService';

// master_data/batch_mdata
export const getBatchDetails = createAsyncThunk('batch-details', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/master_data/batch_mdata`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data || 'Something went wrong');
        } else {
            return rejectWithValue(error.response.data || 'Something went wrong');
        }
    }
});
// api/master_data/add-batch
export const saveBatchDetails = createAsyncThunk('save-batch-details', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/master_data/add-batch`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data || 'Something went wrong');
        } else {
            return rejectWithValue(error.response.data || 'Something went wrong');
        }
    }
});
// master_data/project_mdata
export const getProjectDetails = createAsyncThunk('project-details', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/master_data/project_mdata`, payload);

        return data;
    } catch (error: any) {

        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data || 'Something went wrong');
        } else {
            return rejectWithValue(error.response.data || 'Something went wrong');
        }
    }
});
export const saveProjectMasterDetails = createAsyncThunk('add-project-details', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/master_data/add-project`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data || 'Something went wrong');
        } else {
            return rejectWithValue(error.response.data || 'Something went wrong');
        }
    }
});
// master_data/candidatebatchinfo/95
export const getBatchInfo = createAsyncThunk('get-batch-details', async (id: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.get(`api/api/master_data/get_batchinfo/${id}`);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.response.data);
        }
    }
});
// menu/get_overall_candidates
export const getAllCandidates = createAsyncThunk('get-batch-candidates-all', async () => {
    try {
        const { data } = await ax.get(`api/api/menu/get_overall_candidates`);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return error.response.data;
        } else {
            return error.response.data;
        }
    }
});
// get project batch
export const getProjectBatchInfo = createAsyncThunk('get-project-batch-details', async (id: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.get(`api/api/master_data/get_projectinfo/${id}`);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.response.data);
        }
    }
});
// master_data/remove_batch
export const removeBatchMaster = createAsyncThunk('remove-batch-master', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/master_data/remove_batch`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.response.data);
        }
    }
});

export const removeProjectMaster = createAsyncThunk('remove-project-master', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/master_data/remove_project`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.response.data);
        }
    }
});

// menu/master_degree
export const saveSpecialisation = createAsyncThunk('save-specialisation-master', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/Lms/create_masspecialisation`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.response.data);
        }
    }
});
// Lms/masspecialisation_list
export const getAllSpecialisation = createAsyncThunk('get-all-specialisation-master', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/Lms/masspecialisation_list`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.response.data);
        }
    }
});
// /Lms/get_masspecialisation
export const getSpecialisation = createAsyncThunk('get-specialisation', async (id: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.get(`api/api/Lms/get_masspecialisation/${id}`);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.response.data);
        }
    }
});
// menu/remove_master_degree/3
export const deleteDegree = createAsyncThunk('delete-specialisation-master', async (id: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.get(`api/api/menu/remove_master_degree/${id}`);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.response.data);
        }
    }
});
// Lms/create_subject
export const saveSubject = createAsyncThunk('save-subject-master', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/Lms/create_subject`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.response.data);
        }
    }
});
// Lms/massubject_list
export const getAllSubject = createAsyncThunk('get-all-subject-master', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/Lms/massubject_list`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.response.data);
        }
    }
});
export const getSubject = createAsyncThunk('get-subject', async (id: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.get(`api/api/Lms/get_massubject/${id}`);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.response.data);
        }
    }
});
// /Lms/create_group
export const saveGroup = createAsyncThunk('save-group-master', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/Lms/create_group`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.response.data);
        }
    }
});
export const getGroup = createAsyncThunk('get-group', async (id: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.get(`api/api/Lms/get_group/${id}`);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.response.data);
        }
    }
});
//api/Lms/group_list
export const getAllGroup = createAsyncThunk('get-all-group-master', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/Lms/group_list`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.response.data);
        }
    }
});
// Lms/create_mascourse
export const saveCourse = createAsyncThunk('save-course-master', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/Lms/create_mascourse`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.response.data);
        }
    }
});

export const getAllCourse = createAsyncThunk('get-all-course-master', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/Lms/mascourse_list`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.response.data);
        }
    }
});
// Lms/get_mascourse/1/0
export const getCourse = createAsyncThunk('get-course', async (id: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.get(`api/api/Lms/get_mascourse/${id}`);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.response.data);
        }
    }
});

// Lms/delete_masgroup/1/2
export const deleteGroup = createAsyncThunk('delete-group', async (id: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.get(`api/api/Lms/delete_masgroup/${id}`);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.response.data);
        }
    }
});

// Lms/delete_masspecialisation/1/5
export const deleteSpecialization = createAsyncThunk('delete-specialization', async (id: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.get(`api/api/Lms/delete_masspecialisation/${id}`);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.response.data);
        }
    }
});

// Lms/delete_massubject/1/8
export const deleteSubject = createAsyncThunk('delete-subject', async (id: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.get(`api/api/Lms/delete_massubject/${id}`);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.response.data);
        }
    }
});

// Lms/delete_mascourse/1/8
export const deleteCourse = createAsyncThunk('delete-course', async (id: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.get(`api/api/Lms/delete_mascourse/${id}`);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.response.data);
        }
    }
});
// Lms/remove_mascoursespecz
export const deleteCourseSpec = createAsyncThunk('delete-course-specialisation', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/Lms/remove_mascoursespecz`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.response.data);
        }
    }
});

export const saveSyllabus = createAsyncThunk('save-syllabus',async(payload:any,{rejectWithValue})=>{
    try{
        const {data} = await ax.post(`api/api/Account/saveSyllabus`,payload);
        return data;
    }catch(error:any){
         if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.response.data);
        }
    }
})

export const getSyllabus = createAsyncThunk('get-syllabus', async (id: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.get(`api/api/Account/getSyllabusAsync/${id}`);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.response.data);
        }
    }
});
// Account/deleteSyllabusAsync/1/1210
export const deleteSyllabus = createAsyncThunk('delete-syllabus', async (id: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.delete(`api/api/Account/deleteSyllabusAsync/${id}`);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.response.data);
        }
    }
});

// Lms/get_maspubcourse/1/0
export const getPublicCourse = createAsyncThunk('get-public-course', async (id: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.get(`api/api/Lms/get_maspubcourse/${id}`);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.response.data);
        }
    }
});